// This dictionary contains 1 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { localization } from "../localizationManager";

export var norwegianStrings = {
  groupButton: "Grupper",
  ungroupButton: "Opphev gruppering",
  selectButton: "Velg",
  hideColumn: "Skjul kolonne",
  showColumn: "Vis kolonne",
  makePrivateColumn: "Gjør kolonne privat",
  makePublicColumn: "Gjør kolonne offentlig",
  moveToDetail: "Flytt til detaljert visning",
  showAsColumn: "Vis som kolonne",
  filterPlaceholder: "Søk...",
  removeRows: "Fjern rader",
  showLabel: "Vis",
  entriesLabel: "oppføringer",
  visualizer_text: "Tabellvisning",
  visualizer_wordcloud: "Ordsky",
  visualizer_histogram: "Histogram",
  visualizer_number: "Gjennomsnitt",
  visualizer_choices: "Bord",
  visualizer_selectBase: "Sjøkart",
  // visualizer_matrix: "Chart",
  chartType_bar: "Stolpediagram",
  chartType_vbar: "Vertikal stolpe",
  chartType_stackedbar: "Stablet stolpediagram",
  chartType_doughnut: "Hjuldiagram",
  chartType_pie: "Sektordiagram",
  chartType_scatter: "Punktdiagram",
  chartType_gauge: "Målediagram",
  chartType_bullet: "Kulediagram",
  hideButton: "Skjul",
  makePrivateButton: "Gjør privat",
  makePublicButton: "Gjør offentlig",
  showButton: "Vis",
  filter: "Filter",
  resetFilter: "Nullstill filter",
  changeLocale: "Bytt språk",
  clearButton: "Tøm",
  addElement: "Velg spørsmål...",
  defaultOrder: "Standard",
  ascOrder: "Stigende",
  descOrder: "Synkende",
  showMinorColumns: "Vis mindre kolonner",
  otherCommentTitle: "Annet og kommentarer",
  showPercentages: "Vis prosenter",
  hidePercentages: "Skjul prosenter",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Overgå",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Last ned plott som en PNG-fil",
  hideEmptyAnswers: "Skjul tomme svar",
  showEmptyAnswers: "Vis tomme svar",
  "topNValueText-1": "Alle svar",
  topNValueText5: "Topp 5 svar",
  topNValueText10: "Topp 10 svar",
  topNValueText20: "Topp 20 svar",
  hideMissingAnswers: "Skjul manglende svar",
  showMissingAnswers: "Vis manglende svar",
  missingAnswersLabel: "Mangler svar",
  noVisualizerForQuestion: "Denne spørsmålstypen er ikke visualisert ennå",
  noResults: "Det er ingen resultater ennå",
  showPerValues: "Per verdier",
  showPerColumns: "Per kolonner",
  answer: "Svare",
  correctAnswer: "Riktig svar: ",
  percent: "Prosent",
  responses: "Svar"
};

localization.locales["no"] = norwegianStrings;
localization.localeNames["no"] = "Norsk";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.visualizer_histogram: "Histogram" => "Histogram"
// undefined.visualizer_number: "Average" => "Gjennomsnitt"
// undefined.visualizer_choices: "Table" => "Bord"
// undefined.visualizer_selectBase: "Chart" => "Sjøkart"
// undefined.chartType_vbar: "Vertical Bar" => "Vertikal stolpe"
// undefined.filter: "Filter" => "Filter"
// undefined.pdfDownloadCaption: "PDF" => "PDF"
// undefined.xlsxDownloadCaption: "Excel" => "Overgå"
// undefined.csvDownloadCaption: "CSV" => "CSV"
// undefined.saveDiagramAsPNG: "Download plot as a PNG file" => "Last ned plott som en PNG-fil"
// undefined.hideEmptyAnswers: "Hide empty answers" => "Skjul tomme svar"
// undefined.showEmptyAnswers: "Show empty answers" => "Vis tomme svar"
// undefined.topNValueText-1: "All answers" => "Alle svar"
// undefined.topNValueText5: "Top 5 answers" => "Topp 5 svar"
// undefined.topNValueText10: "Top 10 answers" => "Topp 10 svar"
// undefined.topNValueText20: "Top 20 answers" => "Topp 20 svar"
// undefined.hideMissingAnswers: "Hide missing answers" => "Skjul manglende svar"
// undefined.showMissingAnswers: "Show missing answers" => "Vis manglende svar"
// undefined.missingAnswersLabel: "Missing answers" => "Mangler svar"
// undefined.noVisualizerForQuestion: "This question type is not visualized yet" => "Denne spørsmålstypen er ikke visualisert ennå"
// undefined.noResults: "There are no results yet" => "Det er ingen resultater ennå"
// undefined.showPerValues: "Per Values" => "Per verdier"
// undefined.showPerColumns: "Per Columns" => "Per kolonner"
// undefined.answer: "Answer" => "Svare"
// undefined.correctAnswer: "Correct answer: " => "Riktig svar: "
// undefined.percent: "Percent" => "Prosent"
// undefined.responses: "Responses" => "Svar"